import { Box, UnstyledButton } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import useViewAs from '@app/shared/providers/ViewAsProvider/useViewAs';
import { parseUserName } from '@app/shared/helpers/auth';

import * as classes from './styles/index.css';

function ViewAsBanner() {
  const { t } = useTranslation();
  const { viewAsUser, exitViewAs } = useViewAs();

  if (!viewAsUser) return null;

  const { fullName } = parseUserName(viewAsUser);
  const displayName = fullName || viewAsUser.email;

  return (
    <Box className={classes.banner} role="status">
      <IconEye size={16} />
      <span>
        {t('User:ViewAs.banner.message', {
          userName: displayName,
          userEmail: viewAsUser.email,
        })}
      </span>
      <UnstyledButton
        type="button"
        className={classes.exitButton}
        onClick={() => exitViewAs()}
      >
        {t('User:ViewAs.banner.exit')}
      </UnstyledButton>
    </Box>
  );
}

export default ViewAsBanner;
